import React from 'react';
import { useTranslation } from 'react-i18next';

import { useVatText } from 'hooks/useVatText';

import css from './promoteVipPopupLegal.module.sass';

interface Props {
  currency: string;
  price: string;
  recurrentDuration: number;
}

export const PromoteVipPopupLegal: React.FC<Props> = ({
  currency,
  price,
  recurrentDuration,
}) => {
  const { t } = useTranslation('app');

  const { isVatTextEnabled } = useVatText();

  return (
    <p className={css.root}>
      {t('promoteVipPopup.legal', {
        currency,
        price,
        duration: recurrentDuration,
      })}
      {isVatTextEnabled && <p>{t('payment.vatText')}</p>}
    </p>
  );
};
